import { Component, Input } from '@angular/core';

@Component({
  selector: 'bms-common-title-section',
  templateUrl: './bms-common-title-section.component.html',
  styleUrls: ['./bms-common-title-section.component.scss'],
})
export class BMSCommonTitleSectionComponent {
  @Input() icon: string;
  @Input() title: string;
  @Input() subTitle: string;
}
